export const matchesCRMSearch = (entity, query, student = null) => {
  const normalized = String(query || "").trim().toLowerCase().replace(/\s+/g, " ");
  if (!normalized) return true;
  if (!entity) return false;

  const students = student ? [student] : entity.students || [];
  const names = [entity.fullName, entity.name, ...students.map((entry) =>
    typeof entry === "string" ? entry : entry?.name || entry?.fullName
  )];
  if (names.some((name) => String(name || "").toLowerCase().replace(/\s+/g, " ").includes(normalized))) {
    return true;
  }

  const digits = normalized.replace(/\D/g, "");
  return Boolean(digits && /^[\d\s()+.-]+$/.test(normalized) &&
    [entity.phone, entity.alternatePhone].some((phone) =>
      String(phone || "").replace(/\D/g, "").includes(digits)
    ));
};
